export interface OpenPopoverEntry {
  id: symbol;
  contains: (target: Node) => boolean;
}

const openPopovers: OpenPopoverEntry[] = [];
const handledEscapeEvents = new WeakSet<Event>();

export const markPopoverOpen = (entry: OpenPopoverEntry): void => {
  removeOpenPopover(entry);
  openPopovers.push(entry);
};

export const removeOpenPopover = (entry: OpenPopoverEntry): void => {
  const index = openPopovers.findIndex(openPopover => openPopover.id === entry.id);
  if (index !== -1) openPopovers.splice(index, 1);
};

export const shouldHandlePopoverEscape = (entry: OpenPopoverEntry, event: Event, targets: (Node | null)[]): boolean => {
  if (handledEscapeEvents.has(event)) return false;

  const openPopoversByRecency = [...openPopovers].reverse();

  for (const target of targets) {
    if (!target) continue;

    const owner = openPopoversByRecency.find(openPopover => openPopover.contains(target));
    if (owner) {
      if (owner.id !== entry.id) return false;

      handledEscapeEvents.add(event);
      return true;
    }
  }

  if (openPopoversByRecency[0]?.id !== entry.id) return false;

  handledEscapeEvents.add(event);
  return true;
};
